var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoboticArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 159.37,
    y1: 34.72,
    x2: 116.4,
    y2: 59.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.81,
    y1: 94.43,
    x2: 100.81,
    y2: 128.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,73.28a5.39,5.39,0,1,1-5.38-5.45A5.42,5.42,0,0,1,107,73.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.12,73.21a19.66,19.66,0,1,1-19.66-19.84A19.75,19.75,0,0,1,121.12,73.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.65,162.15h17l.58,30.89m0,0a32.18,32.18,0,1,0-17.62-.27V162.15h17.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoboticArm);
export default __webpack_public_path__ + "static/media/ROBOTIC_ARM.1b44bcd76e2f5da704da9f608577abfb.svg";
export { ForwardRef as ReactComponent };